module.exports = __webpack_public_path__ + "img/list4.50450c2c.png";